import { OSHighwaysRoyaltyData } from "../../../types/Royalties/OSHighwaysRoyaltyData";

export interface OSHighwaysRoyaltyDetailsProps {
  royaltyData: OSHighwaysRoyaltyData;
}

const OSHighwaysRoyaltyDetails = ({ royaltyData }: OSHighwaysRoyaltyDetailsProps) => {
  return (
    <>
      <dt>Number of User/Terminals</dt>
      <dd>{royaltyData.users}</dd>
      <dt>Roads Number of High Density Tiles</dt>
      <dd>{royaltyData.roadsHighDensityTiles}</dd>
      <dt>Roads Number of Medium Density Tiles</dt>
      <dd>{royaltyData.roadsMediumDensityTiles}</dd>
      <dt>Roads Number of Low Density Tiles</dt>
      <dd>{royaltyData.roadsLowDensityTiles}</dd>
      <dt>Roads Number of Zero Density Tiles</dt>
      <dd>{royaltyData.roadsZeroDensityTiles}</dd>
      <dt>Paths Number of High Density Tiles</dt>
      <dd>{royaltyData.pathsHighDensityTiles}</dd>
      <dt>Paths Number of Medium Density Tiles</dt>
      <dd>{royaltyData.pathsMediumDensityTiles}</dd>
      <dt>Paths Number of Low Density Tiles</dt>
      <dd>{royaltyData.pathsLowDensityTiles}</dd>
      <dt>Paths Number of Zero Density Tiles</dt>
      <dd>{royaltyData.pathsZeroDensityTiles}</dd>
    </>
  );
};

export default OSHighwaysRoyaltyDetails;
